import { createApiClient } from '@familywallet/api-client';

type Listener = (signedIn: boolean) => void;
const listeners = new Set<Listener>();

/** Subscribe to sign-in / sign-out (including a session ended by the server). */
export function onAuthChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * The one API client for the web app. Same origin: the API serves this app under /api/v1.
 * The access token stays in memory; the refresh token is an httpOnly cookie the page cannot read.
 */
export const api = createApiClient({
  baseUrl: '',
  onAuthChange: (signedIn) => listeners.forEach((listener) => listener(signedIn)),
});
